import { Point, Polygon, Segment } from '@flatten-js/core';

export function getSelectionFlattenPolygon(globalStart, globalEnd) {
  const points = [
    globalStart,
    { x: globalStart.x, y: globalEnd.y },
    globalEnd,
    { x: globalEnd.x, y: globalStart.y },
    globalStart,
  ];
  const segments = getFlattenSegmentsFromPoints(points);

  const polygon = new Polygon();
  polygon.addFace(segments);
  return polygon;
}

export function selectAreaPointsByPolygon(heightsArea, polygon) {
  return heightsArea.heightPoints.filter(point => {
    return polygon.contains(point.flattenPoint);
  });
}

function getFlattenSegmentsFromPoints(closedPoints) {
  const segments = [];
  for (let i = 0; i < closedPoints.length - 1; i++) {
    segments.push(
      new Segment(
        new Point(closedPoints[i].x, closedPoints[i].y),
        new Point(closedPoints[i + 1].x, closedPoints[i + 1].y)
      )
    );
  }

  return segments;
}
